import React from 'react';
import './MikaPageHeader.scss';

interface MikaPageHeaderProps {
    title: string | React.ReactNode;
    subtitle?: string;
    actions?: React.ReactNode;
    breadcrumb?: React.ReactNode;
    onBack?: () => void;
    rightContent?: React.ReactNode;
}

const MikaPageHeader: React.FC<MikaPageHeaderProps> = ({
    title,
    subtitle,
    actions,
    breadcrumb,
    onBack,
    rightContent
}) => {
    return (
        <div className="mika-page-header">
            {breadcrumb && <div className="mika-page-breadcrumb">{breadcrumb}</div>}
            <div className="mika-page-header-row">
                {onBack && (
                    <button type="button" className="mika-page-back" onClick={onBack} aria-label="Back">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <line x1="19" y1="12" x2="5" y2="12" />
                            <polyline points="12 19 5 12 12 5" />
                        </svg>
                    </button>
                )}
                <div className="mika-page-header-info">
                    <h1 className="mika-page-title">{title}</h1>
                    {subtitle && <span className="mika-page-subtitle">{subtitle}</span>}
                </div>
                {actions && <div className="mika-page-header-actions">{actions}</div>}
                {rightContent && <div className="mika-page-header-right">{rightContent}</div>}
            </div>
        </div>
    );
};

export default MikaPageHeader;
